import {
  useExecutiveReportFields,
  buildPresentation,
} from '@features/executive-report/subdomains/cpg';
import { presentationToFile } from '@features/powerpoint';
import {
  Campaign,
  CpgReportsParams,
  GetCampaignParams,
} from '@features/campaigns';
import { useCurrentUser } from '@features/users';
import { stringify } from 'qs';
import { useNavigate } from 'react-router-dom';
import { ExecutiveReportDownloadButton } from './ExecutiveReportDownload';
import { clientDefaultValues } from '@features/executive-report/subdomains/cpg';
import { useFeatures } from '@utils/hooks';
import { BuildReportOptions } from '@features/executive-report/subdomains/cpg/utils/build-presentation';
import { defaultValues } from '@features/executive-report/subdomains/cpg/domain/v2/default-values';

type CpgExecutiveReportDownloadProps = {
  campaignId: Campaign['id'];
  reportParams: Omit<CpgReportsParams, 'campaignId'>;
  campaignParams: GetCampaignParams;
};

export const CpgExecutiveReportDownload = ({
  campaignId,
  campaignParams,
  reportParams,
}: CpgExecutiveReportDownloadProps) => {
  const navigate = useNavigate();

  const { role: userRole } = useCurrentUser();
  const { data, loading } = useExecutiveReportFields({
    campaignParams: { ...campaignParams, id: campaignId },
    reportParams,
  });
  const { pptRedesign } = useFeatures();

  const onClickHandler = () => {
    if (userRole === 'user') {
      if (!data) throw new Error('Missing data for presentation');

      const options: BuildReportOptions = pptRedesign
        ? {
            ...data,
            designVersion: 'v2',
            brandLogo: null,
            customFields: defaultValues(data.campaign.name, {}),
          }
        : {
            ...data,
            designVersion: 'v1',
            brandLogo: null,
            customFields: clientDefaultValues(data.campaign.name),
          };

      const presentation = buildPresentation(options);

      void presentationToFile(presentation);
    } else {
      void navigate(
        `/campaigns/cpg/${campaignId}/executive-report?${stringify({
          ...campaignParams,
          ...reportParams,
        })}`
      );
    }
  };

  return (
    <ExecutiveReportDownloadButton
      disabled={!data}
      loading={loading}
      onClickHandler={onClickHandler}
    />
  );
};
